import { useState, useMemo, useEffect } from 'react';

import Image from 'next/image';

import MainContent from './components/MainContent';
import Sidebar from './components/Sidebar';

export default function SelectionList({ selectionCatalogListData, selectionProductPageData }) {
  const [inputValue, setInputValue] = useState('');
  const [selectedKeys, setSelectedKeys] = useState(['0']);
  const [expandedKeys, setExpandedKeys] = useState([]);

  const normalizedCatalogList = useMemo(() => {
    const sortedList = sortCatalogList(selectionCatalogListData);
    return sortedList;
  }, [selectionCatalogListData]);

  function sortCatalogList(catalog) {
    return catalog
      .map((item) => {
        // 先复制对象，避免修改原对象
        const newItem = { ...item };
        // 提取数字前缀用于排序
        const numMatch = item.catalogName.match(/^(\d+)\./);
        newItem.sortKey = numMatch ? parseInt(numMatch[1]) : Infinity;
        return newItem;
      })
      .sort((a, b) => a.sortKey - b.sortKey) // 根据数字前缀排序
      .map((item) => {
        // 去除数字前缀
        const cleanedName = item.catalogName.replace(/^\d+\./, '');
        return {
          ...item,
          originalName: item.catalogName, // 保留原始名称
          catalogName: cleanedName,
          // 子目录保持不变
          children: item.children,
        };
      });
  }

  const catalogList = useMemo(() => {
    const preData = {
      catalogName: '热门推荐',
      key: '0',
    };
    const data = normalizedCatalogList ? [preData, ...normalizedCatalogList] : [preData];
    return addKeys(data);
  }, [normalizedCatalogList]);

  function addKeys(data, parentKey = '') {
    return data.map((item, index) => {
      const currentKey = parentKey ? `${parentKey}-${index}` : `${index}`;
      return {
        title: item.catalogName,
        originalName: item.originalName,
        key: currentKey,
        children: item.children?.length ? addKeys(item.children, currentKey) : null,
      };
    });
  }

  // 实时搜索效果 - 当inputValue变化时自动应用搜索
  useEffect(() => {
    if (inputValue.trim()) {
      // 如果有搜索内容，展开所有节点以便显示搜索结果
      const allKeys = getAllKeys(catalogList);
      setExpandedKeys(allKeys);
    } else {
      // 如果没有搜索内容，收起所有节点
      setExpandedKeys([]);
    }
  }, [inputValue, catalogList]);

  // 获取所有key的函数
  function getAllKeys(data) {
    let keys = [];
    data.forEach((item) => {
      keys.push(item.key);
      if (item.children) {
        keys = [...keys, ...getAllKeys(item.children)];
      }
    });
    return keys;
  }

  const onSelect = ({ selectedKeys }) => {
    setSelectedKeys(selectedKeys);
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  return (
    <div className="mt-[15px] flex items-start">
      <div className="bg-white py-[20px] w-[220px] rounded-[20px] shrink-0">
        <h2 className="ml-[20px] mb-[14px] text-[18px]">电路功能导航</h2>
        <div className="mx-[auto] px-[16px] flex items-center w-[178px] h-[30px] rounded-[15px] border border-solid border-[#B8BEC9]">
          <input
            className="flex-1"
            type="text"
            placeholder="请输入功能搜索"
            onChange={(e) => setInputValue(e.target.value)}
            value={inputValue}
          />
          <Image
            src="https://static.szlcsc.com/ecp/assets/newWeb/www/selection/search.svg"
            alt="搜索图标"
            width="14"
            height="12"
          />
        </div>
        <Sidebar
          catalogList={catalogList}
          searchValue={inputValue} // 直接使用inputValue作为搜索值
          selectedKeys={selectedKeys}
          expandedKeys={expandedKeys}
          onSelect={onSelect}
          onExpand={onExpand}
        />
      </div>
      <MainContent
        catalogList={catalogList}
        selectedKeys={selectedKeys}
        selectionProductPageData={selectionProductPageData}
      />
    </div>
  );
}
